import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    requestClientUsers,
    requestImpersonate,
    requestStopImpersonating,
} from '../support/support';
import { RequestImpersonate } from '../support/types/Support';

export function useClientUsers(clientId: number | undefined) {
    return useQuery({
        queryKey: [`clientUsers-${clientId}`],
        enabled: false,
        queryFn: async ({ signal }) => (await requestClientUsers(clientId, signal)).data,
    });
}

export const useImpersonate = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: RequestImpersonate) => (await requestImpersonate(data)).data,
        onSuccess: async () => {
            queryClient.resetQueries();
        },
    });
};

export const useStopImpersonating = () => {
    return useMutation({
        mutationFn: async () => (await requestStopImpersonating()).data,
    });
};
